import React, { useState, useEffect } from 'react';
import {
  Box,
  Grid,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Paper
} from '@mui/material';
import { PrimaryButton } from 'components/Buttons';  // your custom button
import Colors from 'assets/Style/Colors';            // your color file
import Pagination from 'components/Pagination';      // your custom pagination
import styled from "@emotion/styled";
import { tableCellClasses } from '@mui/material/TableCell';
import { FontFamily } from 'assets';
import InputField from 'components/Input';
import { useForm } from 'react-hook-form';
import ReconcileServices from 'services/Reconciling';
import moment from 'moment';
import { CommaSeparator } from 'utils';
import ApprovalReconciliationDialog from 'components/Dialog/ApprovalReconsilationDialog';
import { SuccessToaster, ErrorToaster } from 'components/Toaster';

// *For Table Style
const Row = styled(TableRow)(() => ({
  border: 0,
}));

const Cell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    border: 0,
    textAlign: "center",
    whiteSpace: "nowrap",
    background: Colors.primary,
    color: Colors.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    textAlign: "center",
    textWrap: "nowrap",
    padding: "5px !important",

    ".MuiBox-root": {
      display: "flex",
      gap: "6px",
      alignItems: "center",
      justifyContent: "center",
      ".MuiBox-root": {
        cursor: "pointer",
      },
    },
    svg: {
      width: "auto",
      height: "24px",
    },
    ".MuiTypography-root": {
      textTransform: "capitalize",
      fontFamily: FontFamily.NunitoRegular,
      textWrap: "nowrap",
    },
    ".MuiButtonBase-root": {
      padding: "8px",
      width: "28px",
      height: "28px",
    },
  },
}));

export default function ReconcilationApproval() {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();
  // Example states for pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [pageLimit, setPageLimit] = useState(10);
  const [totalCount, setTotalCount] = useState(50); // pretend total row count
  const [reconciledList, setReconciledList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);

  // Example table data
  const tableData = [
    {
      date: '12-12-2024',
      coaCode: '7777772',
      bankName: 'Bank DD',
      from: '12-12-2024',
      to: '12-12-2024',
      openingBalance: '250.00',
      closingBalance: '250.00',
      entriesReconciled: 8,
      reconciledBy: 'Aman Ahmad',
      transType: 'Draft',
    },
    {
      date: '12-13-2024',
      coaCode: '999999',
      bankName: 'Bank XYZ',
      from: '12-13-2024',
      to: '12-13-2024',
      openingBalance: '1000.00',
      closingBalance: '1200.00',
      entriesReconciled: 5,
      reconciledBy: 'Jane Doe',
      transType: 'Draft',
    },
    // ... add more rows as needed
  ];


  // Track selected rows


  // Handle pagination changes
  const handlePageChange = (page) => {
    setCurrentPage(page);
    // fetch or filter data with new page
  };

  const handlePageSizeChange = (event) => {
    const newSize = Number(event.target.value);
    setPageLimit(newSize);
    // fetch or filter data with new pageSize
  };
  const fetchReconcileList = async (page = 1, limit = pageLimit, filter = {}) => {
    setLoading(true);
    try {
      const params = { page, limit, ...filter };
      const response = await ReconcileServices.getReconcileList(params);
      // Assuming the API returns data in: response.data.reconciles.rows and count
      if (response?.status) {
        const filteredRows = response.data.rows || [];

        // const filteredRows = allRows.filter(row => row.tran_type === 'submitted');

        const count = filteredRows.length;
        setReconciledList(filteredRows);
        setTotalCount(count);

      }
    } catch (error) {
      console.error("Error fetching reconciliation list:", error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch data when component mounts or when currentPage/pageLimit/search changes
  useEffect(() => {
    fetchReconcileList(currentPage, pageLimit, { search });
  }, []);
  const handleApprovalClick = () => {
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };


  const handleApproveClick = async (id) => {
    if (!id) return;

    const params = {
      id,
      tran_type: 'drafted',
    };

    try {

      const data = await ReconcileServices.getReconcileApproval(params);
      if (data?.status) {
        SuccessToaster('Approved successfully!');
        fetchReconcileList(currentPage, pageLimit, { search });
      } else {
        ErrorToaster(data?.message || 'Approval failed');
      }
    } catch (error) {
      console.error("Approval error:", error);
      ErrorToaster('Something went wrong!');
    }
  };


  const handleApprovalConfirm = () => {
    setDialogOpen(false);
    // Add your logic here
  };
  return (
    <Box sx={{ p: 2, minHeight: '100vh', backgroundColor: '#ffff' }}>
      <ApprovalReconciliationDialog
        open={dialogOpen}
        onClose={handleDialogClose}
        onConfirm={handleApprovalConfirm}
      />
      {/* ========== Top Bar ========== */}
      <Grid container alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
        {/* Page Title (Left) */}
        <Grid item>
          <Typography variant="h5" fontWeight="bold">
            Approval List
          </Typography>
        </Grid>


      </Grid>

      <Grid item xs={12} sm={12} md={12}>
        {/* This Grid acts as a container for the row */}
        <Grid container alignItems="center" spacing={1}>
          {/* Input takes 8 of 12 columns (adjust as desired) */}
          <Grid item xs={4}>
            <InputField
              size="small"
              label="Bank"
              placeholder="Bank"
              register={register("bank")}
              fullWidth
            />
          </Grid>

          {/* Button occupies remaining space or auto width */}
          <Grid item xs="auto" mt={2}>
            <PrimaryButton title="Search" />
          </Grid>
        </Grid>
      </Grid>



      {/* ========== Table & Pagination ========== */}
      <Box
        sx={{
          backgroundColor: '#fff',
          borderRadius: 2,
          p: 2,
          boxShadow: 1,
        }}
      >

        {/* TableContainer to wrap the Table */}
        <TableContainer
          component={Paper}
          sx={{
            boxShadow: '0px 8px 18px 0px #9B9B9B1A',
            borderRadius: 2,
            maxWidth: 'calc(100vw - 330px)',
            maxHeight: 'calc(100vh - 330px)',
          }}
        >
          <Table stickyHeader>
            {/* Table Head with green background */}
            <TableHead
              sx={{
                backgroundColor: Colors.primary, // e.g. a green color
              }}
            >
              <TableRow>
                <Cell
                >
                  Date
                </Cell>
                <Cell
                >
                  COA Code
                </Cell>
                <Cell
                >
                  Bank Name
                </Cell>
                <Cell
                >
                  From
                </Cell>
                <Cell
                >
                  To
                </Cell>
                <Cell
                >
                  Opening Balance
                </Cell>
                <Cell
                >
                  Closing Balance
                </Cell>
                <Cell
                >
                  Entries Reconciled
                </Cell>
                <Cell
                >
                  Reconciled By
                </Cell>
                <Cell
                >
                  Trans_Type
                </Cell>
                <Cell
                >
                  Approved By
                </Cell>
                <Cell
                >
                  Action
                </Cell>
              </TableRow>
            </TableHead>

            {/* Table Body */}
            <TableBody>
              {reconciledList?.map((row, idx) => (
                <Row key={idx}>
                  <Cell>{moment(row?.created_at).format('DD-MM-YYYY')}</Cell>
                  <Cell>{row?.account_id ?? '-'}</Cell>
                  <Cell>{row?.bank?.name ?? '-'}</Cell>
                  <Cell>{moment(row?.statement_start_date).format('DD-MM-YYYY')}</Cell>
                  <Cell>{moment(row?.statement_end_date).format('DD-MM-YYYY')}</Cell>
                  <Cell>{CommaSeparator(parseFloat(row?.opening_bal).toFixed(2))}</Cell>
                  <Cell>{CommaSeparator(parseFloat(row?.closing_bal).toFixed(2))}</Cell>
                  <Cell>{row?.journal_count ?? '-'}</Cell>
                  <Cell>{row?.created_by?.name ?? '-'}</Cell>
                  <Cell>{row?.tran_type ?? '-'}</Cell>
                  <Cell>{row?.approvedBy?.name ?? '-'}</Cell>
                  <Cell>
                    {/* Example Action */}
                    <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>

                      <Typography
                        variant="body2"
                        sx={{ cursor: 'pointer', color: Colors.green, fontWeight: "700", textDecoration: "underline" }}
                        onClick={() => handleApproveClick(row?.id)}  
                        >  
                        {
                          row?.approved_by === null ? (
                            <>
                            Approve
                            </>

                          ) : (
                            <>
                            Approved
                            </>

                          )
                        }                   
                      </Typography>

                      {/* <PrimaryButton title={'Approve'} onClick={() => handleApproveClick(row?.id)} /> */}

                    </Box>
                  </Cell>
                </Row>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* ========== Pagination at the bottom ========== */}
        <Pagination
          currentPage={currentPage}
          pageSize={pageLimit}
          onPageSizeChange={handlePageSizeChange}
          tableCount={tableData.length} 
          totalCount={totalCount}       
          onPageChange={handlePageChange}
        />
      </Box>
    </Box>
  );
}
